import React from "react";
import { Link } from "react-router-dom";

/**
 * Stripe redirects here after checkout. The donation record itself is written
 * by the webhook, not by this page — a browser that never comes back must
 * still produce a receipt, so this screen is purely confirmation.
 */
export function DonateSuccess() {
  return (
    <div className="es-status-page">
      <p className="es-status-page__eyebrow">Thank you</p>
      <h1 className="es-status-page__title">Your donation went through</h1>
      <p className="es-status-page__body">
        Stripe has confirmed your payment and a receipt is on its way to your
        email address. Your gift helps fund bursary places for families who
        need them.
      </p>
      <div className="es-status-page__actions">
        <Link className="es-btn es-btn--primary" to="/">Back to home</Link>
        <Link className="es-btn es-btn--ghost" to="/program">Browse programs</Link>
      </div>
    </div>
  );
}

export function DonateCancelled() {
  return (
    <div className="es-status-page">
      <p className="es-status-page__eyebrow">Checkout cancelled</p>
      <h1 className="es-status-page__title">No payment was taken</h1>
      <p className="es-status-page__body">
        You closed the secure checkout before finishing, so nothing has been
        charged. You're welcome to try again whenever suits you.
      </p>
      <div className="es-status-page__actions">
        <Link className="es-btn es-btn--primary" to="/donate">Try again</Link>
        <Link className="es-btn es-btn--ghost" to="/">Back to home</Link>
      </div>
    </div>
  );
}
